var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2014",
    "data-name": "Group 2014",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.178,
    height: 19.172,
    viewBox: "0 0 19.178 19.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1462",
    "data-name": "Rectangle 1462",
    width: 19.178,
    height: 19.172,
    fill: "#707b87"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1833",
    "data-name": "Group 1833",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M18.393,19.171h-.337a1.59,1.59,0,0,1-.7-.469q-2.378-2.388-4.765-4.767c-.043-.043-.089-.084-.128-.12a.133.133,0,0,0-.032.007l-.077.053A7.717,7.717,0,0,1,.187,9.376C.108,9,.061,8.616,0,8.235V7.186c.012-.06.023-.12.035-.179A14.582,14.582,0,0,1,.4,5.293a7.708,7.708,0,1,1,14.366,5.536c-.256.564-.6,1.088-.924,1.673a.848.848,0,0,1,.119.093q1.438,1.435,2.874,2.872c.684.684,1.372,1.364,2.051,2.053a.957.957,0,0,1-.267,1.565c-.073.033-.149.059-.223.088M1.912,7.695A5.8,5.8,0,1,0,7.733,1.912,5.82,5.82,0,0,0,1.912,7.695",
    transform: "translate(0 0.001)",
    fill: "#707b87"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsSearch);
export default __webpack_public_path__ + "static/media/NewsSearch.a35a37db9815a17e839d985a30ae34fa.svg";
export { ForwardRef as ReactComponent };